import "./AccessTokensPage.scss";

import AccessTokensPage from "./AccessTokensPage";

export default AccessTokensPage;
